const initialState = {
  reports: null,
};

export default function reportsData(state = initialState, action: any) {
  switch (action.type) {
    case "SET_REPORTS":
      const reports = action.payload;
      return {
        ...state,
        reports,
      };
    case "REMOVE_REPORTS":
      return { ...initialState };
    default:
      return state;
  }
}
